import {
  HTTP_DELETESPECIALBYID_FETCHING,
  HTTP_DELETESPECIALBYID_SUCCESS,
  HTTP_DELETESPECIALBYID_FAILED,
} from "././../../Constants";

const initialState = {
  result: null,
  isLoading: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_DELETESPECIALBYID_FETCHING:
      return { ...state, result: null, isLoading: true, isError: false };
    case HTTP_DELETESPECIALBYID_SUCCESS:
      return { ...state, result: payload, isLoading: false, isError: false };
    case HTTP_DELETESPECIALBYID_FAILED:
      return { ...state, result: null, isLoading: false, isError: true };
    default:
      return state;
  }
};
